import { Modal, ModalBody, ModalFooter } from "reactstrap";
import TimeZone from "../../CustomHooks/TimeZone";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useState } from "react";
import API from "../../Network/API";
import { format } from 'date-fns';

export default function EditMeeting(props) {
    const [check_box,setCheckbox]=useState(false)
    const [time_zone, setTimeZone] = useState('Europe/London');
    const [time, setTime] = useState(null);
    const usert_timez = useSelector((state) => state.timeZoneReducer)
    const [timezonename, setTimezoneText] = useState('');
    const [loading, setLoading] = useState(false);
    const getCurrentTimezone = () => {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimezoneText(userTimezone);
    };
    const fileObj = [];

    const handleSubmit = event => {
        event.preventDefault();
        if (typeof title === null) {
            toast.error('Please add title.');
            return false;
        }
        if (typeof time_zone === null) {
            toast.error('Please add time_zone.');
            return false;
        }
        const fd = new FormData();
        fd.append('title', event.target.title.value);
        fd.append('date', event.target.date.value);
        fd.append('time_zone', event.target.time_zone.value);
        fd.append('time', event.target.time.value);
        fd.append('note', event.target.note.value);
       if(event.target.is_notify.checked){
         fd.append('is_notify', 1);
       }
       if(event.target.is_recurring.checked){
        fd.append('is_repeated', 1);
  
        if(event.target.recurring_type.value==""){
          alert("Please select recurrence type");
          return;
        }
        fd.append('recurring_type', event.target.recurring_type.value);
  
      }else{
        fd.append('is_repeated', 0);
        fd.append('recurring_type', 0);
      }

        setLoading(true);
        if (fileObj.length > 0) {
            for (var i = 0; i < fileObj.length; i++) {
                fd.append('img', fileObj[i], fileObj[i].name);
            }
        }

        API.post(`/v3/meeting/update/${props?.meetingRoom?.id}`, fd).then(response => {
            setLoading(false);
            if (response.data.success === true) {
                props.handleShowB()
            }
        }).catch((error) => {
            setLoading(false);
            toast.error(error.response.data.sms);
        });
    }

    const uploadHandler = (e) => {
        fileObj.pop();
        fileObj.push(e.target.files[0])
    }
    const startDate = new Date(props?.meetingRoom?.start_date);
    const formattedDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
    return (
        <>
            <Modal
                isOpen={props.isModalVisible}
                size=""
                scrollable={false}
                toggle={props.handleShowB}
                className={'modal-dialog'} backdrop="static"
            >
                <div className="modal-header border-0 pb-2">
                    <h5 className="modal-title fw-bold text-dark mb-0">Edit Meeting</h5>
                    <button type="button" className="btn-close" onClick={props.handleShowB} aria-label="Close"></button>
                </div>
                <ModalBody className="bg-white px-4 py-0">

                    <div className="meeting-schedule-popup">
                        <form onSubmit={handleSubmit}>
                            <div className="py-0">
                                <p className="text-muted mb-2" style={{fontSize: '12px'}}>
                                    <span className="text-danger">*</span> marked are required
                                </p>
                                <div className="mb-3">
                                    <label htmlFor="Title" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                                        Meeting Title <span className="text-danger">*</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        defaultValue={props?.meetingRoom?.room_title} 
                                        className="form-control py-2 px-3 rounded-2" 
                                        id="Title" 
                                        name="title" 
                                        placeholder="Enter your meeting name" 
                                        style={{fontSize: '14px', borderColor: '#e9ecef'}}
                                        required 
                                    />
                                </div>

                                <div className="row g-2 mb-3">
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="date" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                                            Date <span className="text-danger">*</span>
                                        </label>
                                        <input 
                                            type="date" 
                                            defaultValue={formattedDate} 
                                            name="date" 
                                            className="form-control py-2 px-3 rounded-2" 
                                            id="date" 
                                            style={{fontSize: '14px', borderColor: '#e9ecef'}}
                                            required 
                                        />
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor="time" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                                            Time <span className="text-danger">*</span>
                                        </label>
                                        <input 
                                            type="time" 
                                            defaultValue={props?.meetingRoom?.start_time} 
                                            name="time" 
                                            className="form-control py-2 px-3 rounded-2" 
                                            id="time" 
                                            style={{fontSize: '14px', borderColor: '#e9ecef'}}
                                            required 
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="inputState" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                                        Time Zone <span className="text-danger">*</span>
                                    </label>
                                    <select 
                                        name="time_zone"
                                        id="inputState"
                                        defaultValue={props?.meetingRoom?.time_zone}
                                        className="form-select py-2 px-3 rounded-2"
                                        style={{fontSize: '14px', borderColor: '#e9ecef'}}
                                        required
                                    >
                                        {TimeZone()?.map((zoneName, index) => (
                                            <option
                                                key={index}
                                                value={zoneName}
                                                selected={props?.meetingRoom?.time_zone === zoneName}
                                            >
                                                {zoneName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="Description" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                                        Agenda
                                    </label>
                                    <textarea 
                                        defaultValue={props?.meetingRoom?.note} 
                                        name="note" 
                                        className="form-control py-2 px-3 rounded-2" 
                                        id="Description" 
                                        placeholder="Meeting agenda"
                                        rows="3"
                                        style={{fontSize: '14px', borderColor: '#e9ecef', resize: 'vertical'}}
                                    />
                                </div>

                                {/* <div className="row">
                                    <div className="col-12">
                                        <label htmlFor="cvpotos" className="form-label form-label-font-14">Cover Photos</label>
                                        <div className="meeting-cover-photos position-relative" id="cvpotos">
                                            <input className="meeting-cover-photos-choose-file" type="file" onChange={uploadHandler} accept="image/*" />
                                            <div className="meeting-cover-photos-body">
                                                <div className="text-center">
                                                    <i className="fas fa-cloud-upload" />
                                                    <span>Drag an image here or upload a file</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="mb-3">
                                    <div className="form-check">
                                        <input 
                                            name="is_notify" 
                                            className="form-check-input" 
                                            type="checkbox"  
                                            id="flexCheckChecked"
                                            style={{transform: 'scale(1.1)'}}
                                        />
                                        <label className="form-check-label fw-medium text-dark" htmlFor="flexCheckChecked" style={{fontSize: '13px'}}>
                                            Notify Users
                                        </label>
                                    </div>
                                </div>

                                <div className="row g-2 mb-3">
                                    <div className="col-6">
                                        <div className="form-check">
                                            <input 
                                                onChange={()=>setCheckbox(!check_box)} 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                id="is_recurring" 
                                                name="is_recurring"
                                                style={{transform: 'scale(1.1)'}}
                                            />
                                            <label className="form-check-label fw-medium text-dark" htmlFor="is_recurring" style={{fontSize: '13px'}}>
                                                Recurring Meeting
                                            </label>
                                        </div>
                                    </div>

                                    <div className={`col-6 ${check_box?'d-block':'d-none'}`}>
                                        <select 
                                            className="form-select py-2 px-3 rounded-2" 
                                            name="recurring_type" 
                                            id="recurring_type"
                                            style={{fontSize: '14px', borderColor: '#e9ecef'}}
                                        >
                                            <option value="">Select recurrence</option>
                                            <option value={1}>Daily</option>
                                            <option value={2}>Weekly</option>
                                            <option value={3}>Monthly</option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <ModalFooter className="border-0 pt-2 px-4 pb-3">
                                <div className="d-flex justify-content-end gap-2 w-100">
                                    <button 
                                        type="button" 
                                        onClick={props.handleShowB}
                                        className="btn btn-light rounded-pill px-4 py-2"
                                        style={{fontSize: '13px', fontWeight: '500'}}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn btn-dark rounded-pill px-4 py-2"
                                        style={{fontSize: '13px', fontWeight: '500'}}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                    style={{width: '14px', height: '14px'}}
                                                ></span>
                                                Updating...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa-solid fa-save me-2" style={{fontSize: '12px'}}></i>
                                                Update
                                            </>
                                        )}
                                    </button>
                                </div>
                            </ModalFooter>

                        </form>
                    </div>

                </ModalBody>
            </Modal>
        </>
    )
}